module.exports = __webpack_public_path__ + "img/blyxlogow.42219d83.png";